export default __webpack_public_path__ + "91feddf4bcdd7be8d3dcec1da47b77c6.png";